import { deg2rad } from "@hscmap/angle";
import { RingsTract } from '@/modules/TractModule/RingsTract';
import { vec4, mat4 } from 'gl-matrix';
import { store } from '@/store';

const pixelScale = 0.168 // arcsec / pixel
const tractSize = 36000 // in pixels
const size = 0.5 * tractSize * deg2rad(pixelScale / 3600)
const rt = new RingsTract()

const EXTRA_TRACT_BASE = 900000000000

function tractCorner(tractId: number) {
  if (tractId >= EXTRA_TRACT_BASE) {
    if (store.galaxyCruise.session) {
      return store.galaxyCruise.session.extra_tracts[tractId]
    }
    else {
      return [] as vec4[]
    }
  }
  else {
    const [a, d] = rt.index2ad(tractId)
    const cA = Math.cos(a)
    const sA = Math.sin(a)
    const cD = Math.cos(-d)
    const sD = Math.sin(-d)
    const m = mat4.fromValues(
      cA * cD, cD * sA, -sD, 0,
      -sA, cA, 0, 0,
      cA * sD, sA * sD, cD, 0,
      0, 0, 0, 1)
    const cs = [
      [1, -size, -size, 1],
      [1, +size, -size, 1],
      [1, +size, +size, 1],
      [1, -size, +size, 1],
    ]
    // @ts-ignore
    return cs.map((c) => vec4.transformMat4(vec4.create(), c, m))
  }
}

export { rt as ringsTract }
export { tractCorner }
